module.exports = __webpack_public_path__ + "img/9788987671314.34f7a28c.jpg";